import { render, staticRenderFns } from "./LotsSection.vue?vue&type=template&id=65b20873&scoped=true&"
import script from "./LotsSection.vue?vue&type=script&lang=js&"
export * from "./LotsSection.vue?vue&type=script&lang=js&"
import style0 from "./LotsSection.vue?vue&type=style&index=0&id=65b20873&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b20873",
  null
  
)

export default component.exports